import { tss } from 'tss-react/mui';

export const useStyles = tss.create(() => ({
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '680px',
        maxWidth: '90vw',
        maxHeight: '85vh',
        overflowY: 'unset',
        height: '65vh',
        minHeight: '550px',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        border: '1px solid #e5e7eb',
      },
    },
  },
  dialogTitle: {
    textAlign: 'left',
    padding: '20px 24px',
    borderBottom: '1px solid #e5e7eb',
    // backgroundColor: '#ffffff',
    borderRadius: '12px 12px 0 0',
    '& .MuiTypography-root': {
      fontSize: '18px',
      fontWeight: '600',
      // color: '#1f2937',
    },
  },
  customizedButton: {
    position: 'absolute',
    right: '16px',
    top: '16px',
    padding: '6px',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    color: '#6b7280',
    '&:hover': {
      backgroundColor: '#f3f4f6',
      color: '#374151',
    },
  },
  dialogContent: {
    padding: '0',
  },
  dialogContentFlex: {
    padding: '0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: '#ffffff',
  },
  roomContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: '#ffffff',
  },
  roomInner: {
    maxWidth: '100%',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chatBox: {
    width: '100%',
    // backgroundColor: '#f9fafb',
  },
  callEndedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '40px 24px',
    gap: '16px',
  },
  callEndedIconWrapper: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  callEndedIcon: {
    fontSize: 32,
    color: '#9ca3af',
  },
  callEndedTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#1f2937',
  },
  callEndedDescription: {
    fontSize: '14px',
    color: '#6b7280',
    textAlign: 'center' as const,
    maxWidth: 360,
    lineHeight: 1.5,
  },
  callEndedActions: {
    display: 'flex',
    gap: '12px',
    marginTop: '12px',
  },
  callEndedPrimaryButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 24px',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  callEndedSecondaryButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: '8px',
    padding: '8px 24px',
    fontSize: '14px',
    color: '#374151',
    borderColor: '#d1d5db',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
      color: '#374151',
    },
  },
}));
